import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { CollapseButtonComponent } from 'src/app/base/shared/collapse-button/collapse-button.component';
import { ThemeService } from 'src/app/base/services/theme.service';

@Component({
  selector: 'app-theme-logo-preview',
  templateUrl: './theme-logo-preview.component.html',
  styleUrls: ['./theme-logo-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe, CollapseButtonComponent]
})
export class ThemeLogoPreviewComponent {
  @Input() public isExpanded = true;
  @Input() public logoUrl = '';
  @Input() public hasCustomLogo = false;
  @Output() public toggleExpand = new EventEmitter<void>();

  constructor(private readonly themeService: ThemeService) {
  }

  public get previewUrl(): string {
    return this.logoUrl || this.themeService.getDefaultLogoUrl();
  }

  public toggle(): void {
    this.toggleExpand.emit();
  }
}
